import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { getVideoById } from 'shared/selectors/videos';
import { isFetching } from 'shared/selectors/channel-videos';
import { getPublic as getVideo } from 'widget/redux/server/actions/channel/video/get';

import DataLoader from 'shared/data-components/_data-loader';


@connect((state, ownProps) => ({
  channelVideoData: getVideoById(state, ownProps.videoId),
  isFetching: isFetching(state),
}), {
  getVideo,
})
export default class ChannelVideoLoader extends DataLoader {

  static displayName = 'ChannelVideoLoader';
  static propTypes = {
    channelVideoData: PropTypes.object,
    getVideo: PropTypes.func,
    channelId: PropTypes.string,
    videoId: PropTypes.string,
    lazyChannelVideos: PropTypes.object,
  };

  dependencies = [
    'channelId',
    'videoId',
  ];

  loadData(forceLoad) {
    const { channelId, videoId, getVideo, channelVideoData } = this.props;

    if (!channelId || !videoId) {
      return;
    }

    if (channelVideoData && !forceLoad) {
      return Promise.resolve(channelVideoData);
    }

    return getVideo(channelId, videoId);
  }

  @autobind
  forceFetch() {
    this.loadDataDebounced(true);
  }

  get childProps() {
    return {
      isChannelVideoFetching: this.props.isFetching,
    };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/channel-video.js